// extracted by css-extract-rspack-plugin
export default {"savedUser":"src-modules-auth-components-SavedUser-SavedUser-module__savedUser-To4Y7K","medium":"src-modules-auth-components-SavedUser-SavedUser-module__medium-Wx59Mg","big":"src-modules-auth-components-SavedUser-SavedUser-module__big-i6vDRW","removeButton":"src-modules-auth-components-SavedUser-SavedUser-module__removeButton-OUU6gI","name":"src-modules-auth-components-SavedUser-SavedUser-module__name-AVeOvQ","avatar":"src-modules-auth-components-SavedUser-SavedUser-module__avatar-cVNBWu"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"savedUser\":\"src-modules-auth-components-SavedUser-SavedUser-module__savedUser-To4Y7K\",\"medium\":\"src-modules-auth-components-SavedUser-SavedUser-module__medium-Wx59Mg\",\"big\":\"src-modules-auth-components-SavedUser-SavedUser-module__big-i6vDRW\",\"removeButton\":\"src-modules-auth-components-SavedUser-SavedUser-module__removeButton-OUU6gI\",\"name\":\"src-modules-auth-components-SavedUser-SavedUser-module__name-AVeOvQ\",\"avatar\":\"src-modules-auth-components-SavedUser-SavedUser-module__avatar-cVNBWu\"}";
        // 1793875577566
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  